const homeHeroArrow = () => {
	const arrow = document.querySelector('.hero__pageJump');

	if (arrow) {
		arrow.addEventListener('click', function () {
			let scrollDistance = window.innerHeight * 1;
			window.scrollBy({
				top: scrollDistance,
				behavior: 'smooth',
				duration: 1050,
			});
		});
	}
};

export default homeHeroArrow;
